import React, { useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header";
import "../Gallary/Gallery.css";

// Image Imports
// import banner from "../../../assets/gallery/placeholder-image.jpg";

import Image1 from "../../../assets/gallery/1.webp";
import Image2 from "../../../assets/gallery/2.webp";
import Image3 from "../../../assets/gallery/3.webp";
import Image4 from "../../../assets/gallery/4.webp";
import Image5 from "../../../assets/gallery/5.webp";
import Image6 from "../../../assets/gallery/6.webp";

import Image7 from "../../../assets/gallery/8.webp";
import Image8 from "../../../assets/gallery/9.webp";
import Image9 from "../../../assets/gallery/10.webp";
import Image10 from "../../../assets/gallery/11.webp";
import Image11 from "../../../assets/gallery/12.webp";
import Image12 from "../../../assets/gallery/13.webp";
import Image13 from "../../../assets/gallery/15.webp";
import Image14 from "../../../assets/gallery/16.webp";
import Image15 from "../../../assets/gallery/22.webp";
import Image16 from "../../../assets/gallery/18.webp";
import Image17 from "../../../assets/gallery/19.webp";
import Image18 from "../../../assets/gallery/20.webp";

// Low-res placeholder image (a small blurred version of any of your images)
import placeholder from "../../../assets/gallery/placeholder-image.jpg";

const Gallery = () => {
  const [loadedImages, setLoadedImages] = useState({});
  const [selectedImage, setSelectedImage] = useState(null); // Modal state

  // Define image groups
  const images = [
    { src: Image1, group: "A" },
    { src: Image2, group: "A" },
    { src: Image9, group: "A" },
    { src: Image10, group: "A" },
    { src: Image11, group: "A" },
    { src: Image12, group: "A" },
    { src: Image3, group: "B" },
    { src: Image4, group: "B" },
    { src: Image5, group: "B" },
    { src: Image6, group: "B" },
    { src: Image13, group: "B" },
    { src: Image14, group: "B" },
    { src: Image7, group: "C" },
    { src: Image8, group: "C" },
    { src: Image15, group: "C" },
    { src: Image16, group: "C" },
    { src: Image17, group: "C" },
    { src: Image18, group: "C" },
  ];

  // Handle image load event
  const handleImageLoad = (src) => {
    setLoadedImages((prev) => ({ ...prev, [src]: true }));
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <Header />

      <div className="gallery-title">
        <h2 className="title-name">Gallery</h2>
      </div>

      {/* Photo Gallery */}
      <div className="photo-gallery px-md-5 px-3 pb-5">
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => setSelectedImage(image.src)} // Set the selected image on click
            >
              <img
                src={loadedImages[image.src] ? image.src : placeholder}
                alt={`Gallery item ${index + 1}`}
                onLoad={() => handleImageLoad(image.src)}
                className={`gallery-image ${
                  loadedImages[image.src] ? "loaded" : "placeholder"
                }`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={handleCloseModal}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()} // Prevent modal close on content click
          >
            <span className="close" onClick={handleCloseModal}>
              &times;
            </span>
            <img
              src={selectedImage}
              alt="Selected"
              className="lightbox-image"
              loading="lazy"
            />
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Gallery;
